import Cookies from 'js-cookie';

/**
 * Prende il valore del cookie con il nome name
 * visto che il cookie può contenere solo stringhe, se
 * rilevo che il contenuto è true o false, faccio un cast
 * a boolean
 * @param {string} name nome del cookie
 * @param {string} defaultValue valore di default del cookie
 */
export const getCookieName = (name, defaultValue = '') => {
  let cookieData = defaultValue;
  try {
    cookieData = Cookies.get(name) || defaultValue;
  } catch {
    // eslint-disable-next-line no-empty
  }
  if (['true', 'false'].indexOf(cookieData) > -1) {
    return cookieData === 'true';
  }
  return cookieData;
};


/**
 * dati in input la chiave e il payloade del cookie,
 * setta un cookie della durata indicata. Se non
 * è indicata una durata esplicitamente, il valore
 * viene settato per 30gg
 * @param {object} data dati da impostare
 * @param {string} data.cookieKey chiave del cookie
 * @param {string} data.payload valore del cookie
 * @param {number} expires durata del cookie
 */
export const cookieSet = (data, expires = 30, sameSite = 'lax') => {
  try {
    Cookies.set(data.cookieKey, data.payload.toString(), { expires, sameSite });
  } catch {
    // eslint-disable-next-line no-empty
  }
};
